import { Form } from 'antd'
import { FC } from 'react'
import StampSearchControl from '../../custom-form-controls/stamp-search-control/stamp-search-control'
import { NamePath } from 'antd/es/form/interface'

interface StampSearchProps {
    noStyle?: boolean
    // onChange?: (value: Stamp | NewStamp) => void

    autoFocus?: boolean
    onBlurOfFullField?: () => void
    name?: NamePath
}

const StampSearch: FC<StampSearchProps> = ({
    name = 'stamp',
    noStyle,
    autoFocus,
    onBlurOfFullField,
}) => {
    return (
        <Form.Item name={name} noStyle={noStyle}>
            <StampSearchControl
                // onChange={onChange}
                autoFocus={autoFocus}
                onBlurOfFullField={onBlurOfFullField}
            />
        </Form.Item>
    )
}

export default StampSearch
